'use client';

import { Suspense } from 'react';
import { LoginPage } from '@/views/auth';

export const dynamic = 'force-dynamic';

export default function Login() {
  return (
    <Suspense fallback={<LoginPageSkeleton />}>
      <LoginPage />
    </Suspense>
  );
}

function LoginPageSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="space-y-2 text-center">
        <div className="h-8 bg-gray-200 dark:bg-secondary-800 rounded w-48 mx-auto" />
        <div className="h-4 bg-gray-100 dark:bg-secondary-900 rounded w-64 mx-auto" />
      </div>
      <div className="space-y-4">
        <div className="h-10 bg-gray-100 dark:bg-secondary-900 rounded" />
        <div className="h-10 bg-gray-100 dark:bg-secondary-900 rounded" />
        <div className="h-10 bg-primary-100 dark:bg-primary-900/20 rounded" />
      </div>
    </div>
  );
}
